/**
 * One second in milliseconds.
 */
export const secondMs = 1000;

/**
 * One minute in milliseconds.
 */
export const minuteMs = 60 * secondMs;

/**
 * One hour in milliseconds.
 */
export const hourMs = 60 * minuteMs;

/**
 * One day in milliseconds.
 */
export const dayMs = 24 * hourMs;
